var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.25C4.22887 12.5149 6.30381 13.5219 7.89095 15.1091C9.47808 16.6962 10.4851 18.7711 10.75 21C11.8549 20.363 12.7791 19.4548 13.4353 18.3612C14.0915 17.2675 14.4579 16.0247 14.5 14.75C16.5989 14.0116 18.4317 12.6675 19.7667 10.8875C21.1017 9.10753 21.8789 6.97167 22 4.75C22 3.75544 21.6049 2.80161 20.9016 2.09835C20.1984 1.39509 19.2446 1 18.25 1C16.0283 1.12113 13.8925 1.89833 12.1125 3.23331C10.3325 4.5683 8.98836 6.40111 8.25 8.5C6.97533 8.54209 5.73245 8.90854 4.63883 9.56471C3.54521 10.2209 2.63699 11.1451 2 12.25",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13.5C4.44904 14.2345 3.39707 15.3407 2.72894 16.677C2.06082 18.0132 1.80699 19.5186 2 21C3.48145 21.193 4.98678 20.9392 6.32303 20.2711C7.65927 19.6029 8.76553 18.551 9.5 17.25",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.5C16.4404 8.5 17 7.94036 17 7.25C17 6.55964 16.4404 6 15.75 6C15.0596 6 14.5 6.55964 14.5 7.25C14.5 7.94036 15.0596 8.5 15.75 8.5Z",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.0bf9ddca8982e3bb299d724453c1a3f1.svg";
export { ForwardRef as ReactComponent };